import { API_URL_AWARD_VIDEO_PUBLIC } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getAwardVideo = () =>
  apiInstance({
    url: API_URL_AWARD_VIDEO_PUBLIC,
  });

export default getAwardVideo;
